const selectors = {
  customerAddresses: '[data-customer-addresses]',
  addressCountrySelect: '[data-address-country-select]',
  addressContainer: '[data-address]',
  toggleAddressButton: 'button[aria-expanded]',
  cancelAddressButton: 'button[type="reset"]',
  deleteAddressButton: 'button[data-confirm-message]'
};

const attributes = {
  expanded: 'aria-expanded',
  confirmMessage: 'data-confirm-message'
};

class CustomerAddresses {
  constructor() {
    this.elements = this._getElements();
    if (Object.keys(this.elements).length === 0) return;
    this._setupCountries();
    this._setupEventListeners();
  }

  _getElements() {
    const container = document.querySelector(selectors.customerAddresses);
    return container ? {
      container,
      addressContainer: container.querySelector(selectors.addressContainer),
      toggleButtons: document.querySelectorAll(selectors.toggleAddressButton),
      cancelButtons: container.querySelectorAll(selectors.cancelAddressButton),
      deleteButtons: container.querySelectorAll(selectors.deleteAddressButton),
      countrySelects: container.querySelectorAll(selectors.addressCountrySelect)
    } : {};
  }

  _setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew'
      });
      this.elements.countrySelects.forEach((select) => {
        const formId = select.dataset.formId;
        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector(`AddressCountry_${formId}`, `AddressProvince_${formId}`, {
          hideElement: `AddressProvinceContainer_${formId}`
        });
      });
    }
  }

  _setupEventListeners() {
    this.elements.toggleButtons.forEach((element) => {
      element.addEventListener('click', this._handleAddEditButtonClick);
    });
    this.elements.cancelButtons.forEach((element) => {
      element.addEventListener('click', this._handleCancelButtonClick);
    });
    this.elements.deleteButtons.forEach((element) => {
      element.addEventListener('click', this._handleDeleteButtonClick);
    });
  }

  _toggleExpanded ({ currentTarget }) {
    var target = currentTarget;
    if (target)
      target.setAttribute(
        attributes.expanded,
        (target.getAttribute(attributes.expanded) === 'false').toString()
      );
  }

  _handleAddEditButtonClick({ currentTarget }) {
    this._toggleExpanded;
    $('.bb-account-wrap-address').toggleClass('edit_');
    $(currentTarget).closest('li').toggleClass('edit_');
  }

  _handleCancelButtonClick({ currentTarget }) {
    this._toggleExpanded;
    $('.bb-account-wrap-address').removeClass('edit_');
    $(currentTarget).closest('li').removeClass('edit_');
  }

  _handleDeleteButtonClick({ currentTarget }) {
    // eslint-disable-next-line no-alert
    if (confirm(currentTarget.getAttribute(attributes.confirmMessage))) {
      Shopify.postLink(currentTarget.dataset.target, {
        parameters: { _method: 'delete' },
      });
    }
  }
}

//login recover password
$( document ).ready(function() {
  var location_login  = window.location.pathname;
  var hash_login  = window.location.hash;
  var hash_ = [
                { url:'/account/login'},{ url:'/fr/account/login'},{ url:'/en-us/account/login'},
                { url:'/fr-us/account/login'},{ url:'/en-intl/account/login'},{ url:'/fr-intl/account/login'}
  ];

  hash_.map(getUrl);
  function getUrl(item) {
    if( item.url === location_login ){
      if (hash_login === '#recover') {
        $('.bb-login').addClass('bb-hide');
        $('.bb-login-recover-pass').removeClass('bb-hide');
      }
      else {
        $('.bb-login').removeClass('bb-hide');
        $('.bb-login-recover-pass').addClass('bb-hide')
      }
    }
  }
});

//my account
$( document ).ready(function() {

  var location_  = window.location.pathname;
  var hash_tag  = window.location.hash;
  location_ = location_.indexOf('/account/orders/') > -1 ? '/account/orders' : location_;

  switch(location_) {
    case '/account':
      if (hash_tag === '#orders') {
        $('.my-orders, .mes-commandes').addClass('_active');
        $('.m-my-orders, .m-mes-commandes').prop("selected", true);

        $('.ma-liste, .my-wishlist').removeClass('_active');
        $('.bb-account-my-account').addClass('_hide');
        $('.bb-account-myorders').removeClass('_hide');
      } else {
        $('.my-account, .mon-compte').addClass('_active');
        $('.m-my-account, .m-mon-compte').prop("selected", true);

        $('.ma-liste, .my-wishlist').removeClass('_active');
        $('.bb-account-my-account').removeClass('_hide');
        $('.bb-account-myorders').addClass('_hide');
      }
      break;
    case '/en-us/account':
      if (hash_tag === '#orders') {
        $('.my-orders, .mes-commandes').addClass('_active');
        $('.m-my-orders, .m-mes-commandes').prop("selected", true);

        $('.ma-liste, .my-wishlist').removeClass('_active');
        $('.bb-account-my-account').addClass('_hide');
        $('.bb-account-myorders').removeClass('_hide');
      } else {
        $('.my-account, .mon-compte').addClass('_active');
        $('.m-my-account, .m-mon-compte').prop("selected", true);

        $('.ma-liste, .my-wishlist').removeClass('_active');
        $('.bb-account-my-account').removeClass('_hide');
        $('.bb-account-myorders').addClass('_hide');
      }
      break;
    case '/en-intl/account':
      if (hash_tag === '#orders') {
        $('.my-orders, .mes-commandes').addClass('_active');
        $('.m-my-orders, .m-mes-commandes').prop("selected", true);

        $('.ma-liste, .my-wishlist').removeClass('_active');
        $('.bb-account-my-account').addClass('_hide');
        $('.bb-account-myorders').removeClass('_hide');
      } else {
        $('.my-account, .mon-compte').addClass('_active');
        $('.m-my-account, .m-mon-compte').prop("selected", true);

        $('.ma-liste, .my-wishlist').removeClass('_active');
        $('.bb-account-my-account').removeClass('_hide');
        $('.bb-account-myorders').addClass('_hide');
      }
      break;
    case '/fr/account':
      if (hash_tag === '#orders') {
        $('.my-orders, .mes-commandes').addClass('_active');
        $('.m-my-orders, .m-mes-commandes').prop("selected", true);

        $('.bb-account-my-account').addClass('_hide');
        $('.bb-account-myorders').removeClass('_hide');
      } else {
        $('.my-account, .mon-compte').addClass('_active');
        $('.m-my-account, .m-mon-compte').prop("selected", true);

        $('.bb-account-my-account').removeClass('_hide');
        $('.bb-account-myorders').addClass('_hide');
      }
      break;
    case '/fr-intl/account':
      if (hash_tag === '#orders') {
        $('.my-orders, .mes-commandes').addClass('_active');
        $('.m-my-orders, .m-mes-commandes').prop("selected", true);

        $('.bb-account-my-account').addClass('_hide');
        $('.bb-account-myorders').removeClass('_hide');
      } else {
        $('.my-account, .mon-compte').addClass('_active');
        $('.m-my-account, .m-mon-compte').prop("selected", true);

        $('.bb-account-my-account').removeClass('_hide');
        $('.bb-account-myorders').addClass('_hide');
      }
      break;
    case '/fr-us/account':
      if (hash_tag === '#orders') {
        $('.my-orders, .mes-commandes').addClass('_active');
        $('.m-my-orders, .m-mes-commandes').prop("selected", true);

        $('.bb-account-my-account').addClass('_hide');
        $('.bb-account-myorders').removeClass('_hide');
      } else {
        $('.my-account, .mon-compte').addClass('_active');
        $('.m-my-account, .m-mon-compte').prop("selected", true);

        $('.bb-account-my-account').removeClass('_hide');
        $('.bb-account-myorders').addClass('_hide');
      }
      break;
    case '/account/addresses':
      $('.ma-liste, .my-wishlist').removeClass('_active');
      $('.address-book, .adresses').addClass('_active');
      $('.m-address-book, .m-adresses').prop("selected", true);
      break;
    case '/account/orders':
      $('.my-orders, .mes-commandes').addClass('_active');
      $('.m-my-orders, .m-mes-commandes').prop("selected", true);
      break;
    case '/account/orders':
      $('.my-orders, .mes-commandes').addClass('_active');
      $('.m-my-orders, .m-mes-commandes').prop("selected", true);
      break;
    case '/fr/account/addresses':
      $('.address-book, .adresses').addClass('_active');
      $('.m-address-book, .m-adresses').prop("selected", true);
      break;
    case '/fr/account/orders':
      $('.my-orders, .mes-commandes').addClass('_active');
      $('.m-my-orders, .m-mes-commandes').prop("selected", true);
      break;
    case '/fr-us/account/addresses':
      $('.address-book, .adresses').addClass('_active');
      $('.m-address-book, .m-adresses').prop("selected", true);
      break;
    case '/fr-intl/account/orders':
      $('.my-orders, .mes-commandes').addClass('_active');
      $('.m-my-orders, .m-mes-commandes').prop("selected", true);
      break;
    case '/en-us/account/addresses':
      $('.address-book, .adresses').addClass('_active');
      $('.m-address-book, .m-adresses').prop("selected", true);
      break;
    case '/en-intl/account/orders':
      $('.my-orders, .mes-commandes').addClass('_active');
      $('.m-my-orders, .m-mes-commandes').prop("selected", true);
      break;
    case '/en-intl/account/addresses':
      $('.address-book, .adresses').addClass('_active');
      $('.m-address-book, .m-adresses').prop("selected", true);
      break;
    case '/fr-intl/account/addresses':
      $('.address-book, .adresses').addClass('_active');
      $('.m-address-book, .m-adresses').prop("selected", true);
      break;
    default:
      $('.my-account, .mon-compte').addClass('_active');
      $('.m-my-account, .m-mon-compte').prop("selected", true);
      $('.bb-account-my-account').removeClass('_hide');
  }

  $('.my-orders, .mes-commandes').on('click', function() {
    $('.bb-account-my-account').addClass('_hide');
    $('.bb-account-myorders').removeClass('_hide');
    $('.my-orders, .mes-commandes').addClass('_active');
    $('.m-my-orders, .m-mes-commandes').prop("selected", true);
    $('.my-account, .mon-compte').removeClass('_active');
  });
  $('.bb-btn-address').on('click', function() {
    $('.bb-account-address').addClass('bb-hide');
    $('.bb-account-address-list').addClass('bb-hide');
    $('.bb-pagination').addClass('bb-hide');
    $('.bb-add-address').removeClass('bb-hide');
  });
  $('.bb-btn-reset').on('click', function() {
    $('.bb-account-address').removeClass('bb-hide');
    $('.bb-account-address-list').removeClass('bb-hide');
    $('.bb-pagination').removeClass('bb-hide');
    $('.bb-add-address').addClass('bb-hide');
  });

});

  $('.my-account, .mon-compte').on('click', function() {
    $('.bb-account-my-account').removeClass('_hide');
    $('.bb-account-myorders').addClass('_hide');

    $('.my-account, .mon-compte').addClass('_active');
    $('.m-my-account, .m-mon-compte').prop("selected", true);

    $('.my-orders, .mes-commandes').removeClass('_active');
  });

  $('#dynamic_select').on('change', function () {
    var url = $(this).val();
    if (url) {
      window.location = url;
      dynamicSelected(url);
    }
    return false;
  });

//dynamic select
function dynamicSelected(url) {
    if ( url === '/account#info' || url === '/fr/account#info' || url === '/fr-us/account#info'
        || url === '/fr-intl/account#info' || url === '/en-us/account#info' || url === '/en-intl/account#info' ) {
      $('.my-account, .mon-compte').addClass('_active');
      $('.my-orders, .mes-commandes').removeClass('_active');

      $('.bb-account-my-account').removeClass('_hide');
      $('.bb-account-myorders').addClass('_hide');
    }
    if ( url === '/account#orders' || url === '/fr/account#orders' || url === '/fr-us/account#orders'
        || url === '/fr-intl/account#orders' || url === '/en-us/account#orders' || url === '/en-intl/account#orders' ) {
      $('.my-orders, .mes-commandes').addClass('_active');
      $('.my-account, .mon-compte').removeClass('_active');

      $('.bb-account-my-account').addClass('_hide');
      $('.bb-account-myorders').removeClass('_hide');
    }
}
